<footer class="apple-footer">
  <div class="apple-container">
    <div class="apple-footer-content">
      <!-- Footer Links -->
      <nav class="apple-footer-nav">
        <a routerLink="/faq" class="apple-footer-link">FAQ</a>
        <span class="apple-footer-separator">·</span>
        <a routerLink="/feedback" class="apple-footer-link">Feedback</a>
        <span class="apple-footer-separator">·</span>
        <a routerLink="/impressum" class="apple-footer-link">Impressum</a>
        <ng-container *ngIf="!(authService.isAuthenticated$ | async)">
          <span class="apple-footer-separator">·</span>
          <a (click)="navigateToEmployeeLogin()" class="apple-footer-link apple-footer-link-clickable">Mitarbeiteranmeldung</a>
        </ng-container>
      </nav>

      <!-- Copyright -->
      <div class="apple-footer-copyright">
        <p class="apple-caption">&copy; 2025 NicLen GmbH. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </div>
</footer>
